import { render, staticRenderFns } from "./ProjectStatusSwitcher.vue?vue&type=template&id=2fd04148&scoped=true"
import script from "./ProjectStatusSwitcher.vue?vue&type=script&lang=ts"
export * from "./ProjectStatusSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./ProjectStatusSwitcher.vue?vue&type=style&index=0&id=2fd04148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd04148",
  null
  
)

export default component.exports